// import React, { useContext, useEffect, useState } from "react";
// import {
//   Box,
//   Typography,
//   Select,
//   MenuItem,
//   Grid,
//   TextField,
//   useTheme,
//   useMediaQuery,
// } from "@mui/material";
// import axios from "axios";
// import { AutoTaskAuthContext } from "../Context/AutoTaskContext";
// import { startOfWeek, getISOWeek, format } from "date-fns";
// import { useLocation } from "react-router-dom";
// import { ReactComponent as GoalIcon } from "../assets/icons/goal.svg";
// import { ReactComponent as Recurring } from "../assets/icons/recurring.svg";
// import { ReactComponent as Calender } from "../assets/icons/calender.svg";
// import { ReactComponent as EditIcon } from "../assets/icons/pencil-icon.svg";
// import Banner from "../assets/banner/performance-banner.png";

// import { Doughnut } from "react-chartjs-2";
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
// import TicketCard from "./TicketCard";

// ChartJS.register(ArcElement, Tooltip, Legend);

// const PerformanceStats = () => {
//   const resTheme = useTheme();
//   const isMobile = useMediaQuery(resTheme.breakpoints.down("md"));
//   const location = useLocation();
//   const staffID = location?.state?.staff_id || "";

//   const { userInfo, availableRoles } = useContext(AutoTaskAuthContext) || {};
//   const userName = location?.state?.staff_name || userInfo?.name;
//   const userRole = location?.state?.staff_role || userInfo?.role;
//   const user_id = staffID ? staffID : userInfo?.id;

//   const [goals, setGoals] = useState([]);
//   const [assignedTicket, setAssignedTicket] = useState([]);
//   const [recurringTickets, setRecurringTickets] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [btnStatus, setBtnStatus] = useState(0);

//   const [selectedDate, setSelectedDate] = useState(null);
//   const [selectedWeek, setSelectedWeek] = useState(new Date());
//   const [weekOptions, setWeekOptions] = useState([]);

//   function getInitials(name) {
//     if (!name) return "";
//     const words = name.trim().split(" ").filter(Boolean);
//     const first = words[0][0].toUpperCase();
//     const second = words[1] ? words[1][0].toUpperCase() : "";
//     return first + second;
//   }

//   // --- Fetch tasks and logs
//   useEffect(() => {
//     const fetchLogs = async () => {
//       try {
//         const url = `${process.env.REACT_APP_API_BASE_URL}/api/ticket/tasks/${user_id}`;
//         const response = await axios.get(url);
//         setGoals(response.data.data || []);
//       } catch (error) {
//         console.error("Error fetching goals:", error);
//       }
//     };
//     if (user_id) fetchLogs();
//   }, [user_id]);

//   // --- Fetch tickets assigned to user
//   useEffect(() => {
//     const fetchAssignedTickets = async () => {
//       setLoading(true);
//       try {
//         const urlForAssigned = `${process.env.REACT_APP_API_BASE_URL}/api/ticket/ticketbyassigneduser?assigned_to=${user_id}`;

//         const urlForRecurring = `${process.env.REACT_APP_API_BASE_URL}/api/ticket/getrecurring/${user_id}`;
//         const response = await axios.get(urlForAssigned);
//         setAssignedTicket(response.data.data || []);
//         const recRes = await axios.get(urlForRecurring);
//         setRecurringTickets(recRes.data.data || []);
//       } catch (error) {
//         console.error("Error fetching assigned tickets", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     if (user_id) fetchAssignedTickets();
//   }, [user_id]);

//   // --- Week options (current week -> 1), dropdown scrollable
//   useEffect(() => {
//     const currentWeekNumber = getISOWeek(new Date());
//     const options = [];
//     for (let w = currentWeekNumber; w >= 1; w--) {
//       options.push({ label: `Week ${w}`, value: w });
//     }
//     setWeekOptions(options);
//     setSelectedWeek(new Date());
//   }, []);

//   // --- Flatten nested logs
//   const flattenedLogs = goals.flatMap((task) =>
//     (task.logs || []).map((log) => ({
//       task_id: task.task_id,
//       task_name: task.task_name,
//       target: task.target,
//       ...log,
//     }))
//   );

//   // --- Helpers
//   const colorForPct = (v) => {
//     if (v > 80) return "#4caf50"; // green
//     if (v >= 60) return "#ff9800"; // yellow/orange
//     return "#f44336"; // red
//   };

//   // --- Build week rows (Mon–Fri)
//   const weekdays = ["Mo", "Tu", "We", "Th", "Fr", "Sa"];

//   const selectedWeekStart = startOfWeek(selectedWeek, { weekStartsOn: 1 });
//   const goalRows = goals.map((goal) => {
//     const row = { task_name: goal.task_name };
//     const weekStart = startOfWeek(selectedWeek, { weekStartsOn: 1 });
//     const target = goal.target || 1; // avoid division by zero

//     weekdays.forEach((_, idx) => {
//       const d = new Date(weekStart);
//       d.setDate(weekStart.getDate() + idx);

//       const logForDay = goal.logs.find(
//         (l) => new Date(l.report_date).toDateString() === d.toDateString()
//       );

//       row[weekdays[idx]] = logForDay ? Number(logForDay.completed) : 0;
//     });

//     // calculate total as average percentage
//     const dailyPercentages = weekdays.map((d, idx) => {
//       const completed = row[d] || 0;
//       return (completed / target) * 100;
//     });

//     const total =
//       dailyPercentages.length > 0
//         ? dailyPercentages.reduce((a, b) => a + b, 0) / dailyPercentages.length
//         : 0;

//     row.total = `${Math.round(total)}%`;

//     return row;
//   });

//   // --- Ticket performance stats with overdue
//   const today = new Date();

//   // Filter tickets between selectedDate → today
//   const filteredTickets = assignedTicket.filter((t) => {
//     if (!t.created_at) return false;

//     const createdAt = new Date(t.created_at);
//     if (isNaN(createdAt)) return false;

//     if (selectedDate instanceof Date && !isNaN(selectedDate)) {
//       return createdAt >= selectedDate && createdAt <= today;
//     }

//     // If no valid selectedDate, include all
//     return true;
//   });

//   // Overdue tickets (in_progress + overdue by >= 2 days)
//   const overdueTickets = filteredTickets.filter((t) => {
//     if (!t.deadline) return false;
//     const deadlineDate = new Date(t.deadline);
//     if (isNaN(deadlineDate)) return false;

//     const diffInDays = Math.floor(
//       (today - deadlineDate) / (1000 * 60 * 60 * 24)
//     );

//     return t.status === "in_progress" && diffInDays >= 2;
//   }).length;

//   // Resolved tickets
//   const resolvedTickets = filteredTickets.filter(
//     (t) => t.status === "resolved"
//   ).length;

//   // In-progress (excluding overdue)
//   const inProgressTickets =
//     filteredTickets.filter((t) => t.status === "in_progress").length -
//     overdueTickets;

//   // Totals
//   const totalTickets = resolvedTickets + inProgressTickets + overdueTickets;

//   return (
//     <Box>
//       <Box
//         sx={{
//           position: "relative",
//           width: isMobile ? "100vw" : "100%",
//           height: "136px",
//           marginX: isMobile ? -2 : 0,
//           backgroundImage: `url(${Banner})`,
//           backgroundSize: "cover",
//           backgroundPosition: "top left",
//           backgroundRepeat: "no-repeat",
//           borderRadius: !isMobile ? "0 0  16px 16px" : 0,
//         }}
//       >
//         {/* Overlay content */}
//         <Box
//           sx={{
//             position: "absolute",
//             margin: "0 auto",
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             gap: 1,
//             width: "90%",
//           }}
//         >
//           <Typography
//             sx={{
//               mt: 2,
//               width: 52,
//               height: 52,
//               boxShadow: 4,
//               boxShadow: "inset -2px -2px 4px #005752",
//               borderRadius: 4,
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               fontSize: 22,
//               bgcolor: "#fff",
//               color: "#008080",
//             }}
//           >
//             {getInitials(userName)}
//           </Typography>

//           <Typography sx={{ fontSize: 14, color: "#fff" }}>
//             {userName} | {availableRoles && availableRoles[userRole]}
//           </Typography>
//         </Box>

//         {/* Buttons at bottom */}
//         <Box
//           sx={{
//             flexGrow: 1,
//             px: 2,
//             position: "absolute",
//             bottom: -24,
//             width: "100%",
//           }}
//         >
//           <Grid container spacing={2}>
//             <Grid item xs={6}>
//               <Box
//                 onClick={() => setBtnStatus((prev) => (prev === 1 ? 0 : 1))}
//                 sx={{
//                   width: "100%",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   gap: 1,
//                   p: 2,
//                   borderRadius: 2,
//                   bgcolor: "#E49A00",
//                   color: "#fff",
//                   boxShadow: 12,
//                   height: 48,
//                   fontSize: 16,
//                 }}
//               >
//                 {btnStatus === 0 ? "Recurring" : "Performance"}{" "}
//                 <Recurring style={{ width: "24px", height: "24px" }} />
//               </Box>
//             </Grid>

//             {/* Today replaced with Date TextField */}
//             <Grid item xs={6}>
//               <Box
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   p: 2,
//                   borderRadius: 2,
//                   bgcolor: "#fff",
//                   boxShadow: 12,
//                   height: 48,
//                   fontSize: 16,
//                 }}
//               >
//                 <TextField
//                   type="date"
//                   size="small"
//                   value={selectedDate ? format(selectedDate, "yyyy-MM-dd") : ""}
//                   onChange={(e) => {
//                     if (!e.target.value) {
//                       setSelectedDate(null); // when cleared
//                       return;
//                     }
//                     const newDate = new Date(e.target.value);
//                     if (!isNaN(newDate)) setSelectedDate(newDate);
//                   }}
//                   variant="outlined"
//                   sx={{
//                     "& .MuiInputBase-root": {
//                       fontSize: 14,
//                       height: 24,
//                       padding: 0,
//                     },
//                     "& input": {
//                       padding: 0,
//                     },
//                     "& fieldset": {
//                       border: "none", // remove default border
//                     },
//                     "& .MuiOutlinedInput-root": {
//                       "&.Mui-focused fieldset": {
//                         border: "none", // remove border on focus
//                       },
//                     },
//                     width: "100%",
//                   }}
//                   InputProps={{
//                     disableUnderline: true,
//                   }}
//                 />

//                 {/* <Calender /> */}
//               </Box>
//             </Grid>
//           </Grid>
//         </Box>
//       </Box>

//       {/* RECURRING TICKET LIST */}

//       {btnStatus === 1 && (
//         <Box sx={{ mt: 6 }}>
//           {!Array.isArray(recurringTickets) && (
//             <Typography
//               sx={{ fontSize: 16, color: "gray", textAlign: "center" }}
//             >
//               Loading Recurring Tickets
//             </Typography>
//           )}
//           {Array.isArray(recurringTickets) && recurringTickets.length == 0 && (
//             <Typography
//               sx={{ fontSize: 16, color: "gray", textAlign: "center" }}
//             >
//               No Recurring Ticktes
//             </Typography>
//           )}

//           {Array.isArray(recurringTickets) && recurringTickets.length > 0 && (
//             <Box sx={{ flexGrow: 1, mt: 0.8, width: "100%" }}>
//               <Grid container spacing={2}>
//                 {recurringTickets.map((ticket, index) => (
//                   <Grid
//                     item
//                     xs={12}
//                     sm={isMobile ? 12 : 4} // ✅ 1 column if mobile, 2 columns otherwise
//                     key={`${ticket.id}-${index}`}
//                   >
//                     <TicketCard ticket={ticket} />
//                   </Grid>
//                 ))}
//               </Grid>
//             </Box>
//           )}
//         </Box>
//       )}

//       {/* TICKET PERFORMANCE */}
//       {btnStatus === 0 && (
//         <Box>
//           {" "}
//           {/* Ticket Performance Doughnut */}
//           <Box
//             sx={{
//               mt: 6,
//               mb: 1,
//               p: 2,
//               border: "1px solid #ddd",
//               borderRadius: 2,
//               display: "flex",
//               alignItems: "center",
//               gap: 2,
//               bgcolor: "#fff",
//             }}
//           >
//             {/* Doughnut Chart */}
//             <Box sx={{ width: 124, height: 124, position: "relative" }}>
//               <Doughnut
//                 data={{
//                   labels: ["Resolved", "Overdue", "In Progress"],
//                   datasets: [
//                     {
//                       data: [
//                         resolvedTickets,
//                         overdueTickets,
//                         inProgressTickets,
//                       ],
//                       backgroundColor: ["#4caf50", "#f44336", "#ff9800"],
//                       borderWidth: 0,
//                     },
//                   ],
//                 }}
//                 options={{
//                   cutout: "65%",
//                   plugins: {
//                     legend: { display: false },
//                     tooltip: { enabled: true },
//                   },
//                   maintainAspectRatio: false,
//                 }}
//               />

//               {/* Center % */}
//               <Box
//                 sx={{
//                   position: "absolute",
//                   top: "50%",
//                   left: "50%",
//                   transform: "translate(-50%, -50%)",
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "center",
//                 }}
//               >
//                 <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
//                   {totalTickets > 0
//                     ? Math.round((resolvedTickets / totalTickets) * 100)
//                     : 0}
//                   %
//                 </Typography>
//                 <Typography variant="caption">Resolved</Typography>
//               </Box>
//             </Box>

//             {/* Custom Legend */}
//             <Box>
//               {[
//                 { label: "Resolved", value: resolvedTickets, color: "#4caf50" },
//                 { label: "Overdue", value: overdueTickets, color: "#f44336" },
//                 {
//                   label: "In Progress",
//                   value: inProgressTickets,
//                   color: "#ff9800",
//                 },
//               ].map((item) => {
//                 const percentage = totalTickets
//                   ? ((item.value / totalTickets) * 100).toFixed(0)
//                   : 0;
//                 return (
//                   <Box
//                     key={item.label}
//                     sx={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 1,
//                       my: 2,
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         width: 14,
//                         height: 14,
//                         borderRadius: "50%",
//                         border: `1px solid ${item.color}`,
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         mx: 1,
//                       }}
//                     >
//                       <Box
//                         sx={{
//                           width: 8,
//                           height: 8,
//                           borderRadius: "50%",
//                           backgroundColor: item.color,
//                         }}
//                       />
//                     </Box>
//                     <Typography sx={{ fontSize: 12 }}>
//                       {item.label} ({percentage}%)
//                     </Typography>
//                   </Box>
//                 );
//               })}
//             </Box>
//           </Box>
//           {/* Goals Week Table */}
//           <Box
//             sx={{
//               border: "1px solid #ddd",
//               borderRadius: 2,
//               overflowX: "auto",
//               mb: 2,
//               p: 1,
//               bgcolor: "#fff",
//             }}
//           >
//             {/* Header row with title + week selector */}
//             <Box
//               sx={{
//                 display: "flex",
//                 justifyContent: "space-between",
//               }}
//             >
//               <Typography
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 1,
//                   fontSize: 14,
//                   height: 56,
//                   paddingLeft: 1.2,
//                 }}
//               >
//                 <GoalIcon /> Daily Goals
//               </Typography>

//               {/* Week Selector */}
//               <Box sx={{ height: 56, display: "flex", alignItems: "center" }}>
//                 <Select
//                   size="small"
//                   value={getISOWeek(selectedWeek)}
//                   onChange={(e) => {
//                     const currentWeek = getISOWeek(new Date());
//                     const weeksBack = currentWeek - Number(e.target.value);
//                     const newDate = new Date();
//                     newDate.setDate(newDate.getDate() - weeksBack * 7);
//                     setSelectedWeek(newDate);
//                   }}
//                   sx={{ mr: 1.2, width: 120, height: 30, fontSize: 14 }}
//                   MenuProps={{
//                     PaperProps: { style: { maxHeight: 200, fontSize: 14 } },
//                   }}
//                 >
//                   {weekOptions.map((w) => (
//                     <MenuItem
//                       sx={{ fontSize: 14 }}
//                       key={w.value}
//                       value={w.value}
//                     >
//                       {w.label}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </Box>
//             </Box>

//             {/* Goal Table Header */}
//             <Box
//               sx={{
//                 borderRadius: 2,
//                 display: "flex",
//                 p: 1,
//                 width: "100%",
//                 boxSizing: "border-box",
//                 bgcolor: "#008080",
//                 color: "white",
//               }}
//             >
//               <Box
//                 sx={{
//                   width: "35%",
//                   textAlign: "left",
//                   fontSize: 14,
//                   whiteSpace: "nowrap",
//                   overflow: "hidden",
//                   textOverflow: "ellipsis",
//                 }}
//               >
//                 Goal
//               </Box>

//               {weekdays.map((d, idx) => (
//                 <Box
//                   key={idx}
//                   sx={{
//                     width: "10%",
//                     textAlign: "center",
//                     fontSize: 14,
//                   }}
//                 >
//                   {d}
//                 </Box>
//               ))}

//               <Box
//                 sx={{
//                   width: "12%",
//                   display: "flex",
//                   justifyContent: "end",
//                   fontSize: 14,
//                 }}
//               >
//                 %
//               </Box>
//             </Box>

//             {/* Rows */}
//             {goalRows.map((row, idx) => {
//               const goal = goals.find((g) => g.task_name === row.task_name);
//               const target = goal?.target || 1; // fallback to 1 to avoid division by 0

//               return (
//                 <Box
//                   key={`${row.task_name}-${idx}`}
//                   sx={{
//                     display: "flex",
//                     borderTop: "1px solid #eee",
//                     p: 1,
//                     width: "100%",
//                     alignItems: "center",
//                     boxSizing: "border-box",
//                     overflow: "hidden",
//                   }}
//                 >
//                   {/* Goal name */}
//                   <Box
//                     sx={{
//                       width: "35%",
//                       pr: 1,
//                       whiteSpace: "nowrap",
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                       fontSize: 12,
//                     }}
//                   >
//                     {row.task_name}
//                   </Box>

//                   {/* Day cells */}
//                   {weekdays.map((d, i) => {
//                     const completed = row[d] || 0;
//                     const pct = Math.min((completed / target) * 100, 100); // percentage for color
//                     const c = colorForPct(pct); // color based on percentage

//                     return (
//                       <Box
//                         key={`${row.task_name}-${d}-${i}`}
//                         sx={{
//                           width: "10%",
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                         }}
//                       >
//                         <Box
//                           title={`${completed}`}
//                           sx={{
//                             width: 14,
//                             height: 14,
//                             borderRadius: "50%",
//                             border: `1px solid ${c}`,
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                           }}
//                         >
//                           {completed > 0 ? (
//                             <Box
//                               sx={{
//                                 width: 8,
//                                 height: 8,
//                                 borderRadius: "50%",
//                                 // backgroundColor: c,
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "center",
//                                 fontSize: 10,
//                                 color: c,
//                                 fontWeight: 600,
//                               }}
//                             >
//                               {completed}
//                             </Box>
//                           ) : (
//                             <Typography
//                               sx={{
//                                 fontSize: 8,
//                                 color: c,
//                                 fontWeight: 600,
//                                 lineHeight: 1,
//                               }}
//                             >
//                               {completed}
//                             </Typography>
//                           )}
//                         </Box>
//                       </Box>
//                     );
//                   })}

//                   {/* Weekly average */}
//                   <Box
//                     sx={{
//                       width: "12%",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "end",
//                     }}
//                   >
//                     <Typography sx={{ fontSize: 12 }}>{row.total}</Typography>
//                   </Box>
//                 </Box>
//               );
//             })}
//           </Box>
//         </Box>
//       )}
//     </Box>
//   );
// };

// export default PerformanceStats;
import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Typography,
  Select,
  MenuItem,
  Grid,
  TextField,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import axios from "axios";
import { AutoTaskAuthContext } from "../Context/AutoTaskContext";
import { startOfWeek, getISOWeek, format } from "date-fns";
import { useLocation } from "react-router-dom";
import { ReactComponent as GoalIcon } from "../assets/icons/goal.svg";
import { ReactComponent as Recurring } from "../assets/icons/recurring.svg";
import { ReactComponent as Calender } from "../assets/icons/calender.svg";
import { ReactComponent as EditIcon } from "../assets/icons/pencil-icon.svg";
import Banner from "../assets/banner/performance-banner.png";

import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import TicketCard from "./TicketCard";

ChartJS.register(ArcElement, Tooltip, Legend);

const PerformanceStats = () => {
  const resTheme = useTheme();
  const isMobile = useMediaQuery(resTheme.breakpoints.down("md"));
  const location = useLocation();
  const staffID = location?.state?.staff_id || "";

  const { userInfo, availableRoles } = useContext(AutoTaskAuthContext) || {};
  const userName = location?.state?.staff_name || userInfo?.name;
  const userRole = location?.state?.staff_role || userInfo?.role;
  const user_id = staffID ? staffID : userInfo?.id;

  const [goals, setGoals] = useState([]);
  const [assignedTicket, setAssignedTicket] = useState([]);
  const [recurringTickets, setRecurringTickets] = useState(null);
  const [loading, setLoading] = useState(false);
  const [btnStatus, setBtnStatus] = useState(0);

  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedWeek, setSelectedWeek] = useState(new Date());
  const [weekOptions, setWeekOptions] = useState([]);

  // ---------- Yes/No per‑question weekly data ----------
  const [yesNoData, setYesNoData] = useState(null);

  function getInitials(name) {
    if (!name) return "";
    const words = name.trim().split(" ").filter(Boolean);
    const first = words[0][0].toUpperCase();
    const second = words[1] ? words[1][0].toUpperCase() : "";
    return first + second;
  }

  // --- Fetch tasks and logs (scoped to selected week) ---
  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const weekStart = startOfWeek(selectedWeek, { weekStartsOn: 1 });
        const fromDate = format(weekStart, "yyyy-MM-dd");
        const toDate = new Date(weekStart);
        toDate.setDate(weekStart.getDate() + 4); // Friday
        const toDateStr = format(toDate, "yyyy-MM-dd");

        const url = `${process.env.REACT_APP_API_BASE_URL}/api/ticket/tasks/${user_id}?from_date=${fromDate}&to_date=${toDateStr}`;
        const response = await axios.get(url);
        setGoals(response.data.data || []);
      } catch (error) {
        console.error("Error fetching goals:", error);
      }
    };
    if (user_id) fetchLogs();
  }, [user_id, selectedWeek]); // ← refetch on week change

  // --- Fetch tickets assigned to user
  useEffect(() => {
    const fetchAssignedTickets = async () => {
      setLoading(true);
      try {
        const urlForAssigned = `${process.env.REACT_APP_API_BASE_URL}/api/ticket/ticketbyassigneduser?assigned_to=${user_id}`;
        const urlForRecurring = `${process.env.REACT_APP_API_BASE_URL}/api/ticket/getrecurring/${user_id}`;
        const response = await axios.get(urlForAssigned);
        setAssignedTicket(response.data.data || []);
        const recRes = await axios.get(urlForRecurring);
        setRecurringTickets(recRes.data.data || []);
      } catch (error) {
        console.error("Error fetching assigned tickets", error);
      } finally {
        setLoading(false);
      }
    };
    if (user_id) fetchAssignedTickets();
  }, [user_id]);

  // --- Week options (current week -> 1), dropdown scrollable
  useEffect(() => {
    const currentWeekNumber = getISOWeek(new Date());
    const options = [];
    for (let w = currentWeekNumber; w >= 1; w--) {
      options.push({ label: `Week ${w}`, value: w });
    }
    setWeekOptions(options);
    setSelectedWeek(new Date());
  }, []);

  // ---------- Fetch Yes/No performance data ----------
  useEffect(() => {
    if (!user_id) return;

    const weekStart = startOfWeek(selectedWeek, { weekStartsOn: 1 });
    const fromDate = format(weekStart, "yyyy-MM-dd");
    const toDate = new Date(weekStart);
    toDate.setDate(weekStart.getDate() + 4); // Friday
    const toDateStr = format(toDate, "yyyy-MM-dd");

    const fetchYesNoPerf = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/yes-no/performance`,
          {
            params: {
              user_id,
              store_id: userInfo.store_id,
              from_date: fromDate,
              to_date: toDateStr,
            },
          },
        );
        if (res.data.success) {
          setYesNoData(res.data.data);
        } else {
          setYesNoData(null);
        }
      } catch (err) {
        console.error("Error fetching yes/no performance:", err);
      }
    };

    fetchYesNoPerf();
  }, [user_id, userInfo?.store_id, selectedWeek]);

  // --- Flatten nested logs (still useful if needed elsewhere)
  const flattenedLogs = goals.flatMap((task) =>
    (task.logs || []).map((log) => ({
      task_id: task.task_id,
      task_name: task.task_name,
      target: task.target,
      ...log,
    })),
  );

  // --- Helpers
  const colorForPct = (v) => {
    if (v > 80) return "#4caf50"; // green
    if (v >= 60) return "#ff9800"; // yellow/orange
    return "#f44336"; // red
  };

  // ✅ Only Monday–Friday
  const weekdays = ["Mo", "Tu", "We", "Th", "Fr"];

  const selectedWeekStart = startOfWeek(selectedWeek, { weekStartsOn: 1 });
  const goalRows = goals.map((goal) => {
    const row = { task_name: goal.task_name };
    const weekStart = startOfWeek(selectedWeek, { weekStartsOn: 1 });
    const target = goal.target || 1; // avoid division by zero

    weekdays.forEach((_, idx) => {
      const d = new Date(weekStart);
      d.setDate(weekStart.getDate() + idx);

      const logForDay = goal.logs.find(
        (l) => new Date(l.report_date).toDateString() === d.toDateString(),
      );

      row[weekdays[idx]] = logForDay ? Number(logForDay.completed) : 0;
    });

    // calculate total as average percentage
    const dailyPercentages = weekdays.map((d, idx) => {
      const completed = row[d] || 0;
      return (completed / target) * 100;
    });

    const total =
      dailyPercentages.length > 0
        ? dailyPercentages.reduce((a, b) => a + b, 0) / dailyPercentages.length
        : 0;

    row.total = `${Math.round(total)}%`;

    return row;
  });

  // --- Ticket performance stats with overdue
  const today = new Date();

  // Filter tickets between selectedDate → today
  const filteredTickets = assignedTicket.filter((t) => {
    if (!t.created_at) return false;

    const createdAt = new Date(t.created_at);
    if (isNaN(createdAt)) return false;

    if (selectedDate instanceof Date && !isNaN(selectedDate)) {
      return createdAt >= selectedDate && createdAt <= today;
    }

    // If no valid selectedDate, include all
    return true;
  });

  // Overdue tickets (in_progress + overdue by >= 2 days)
  const overdueTickets = filteredTickets.filter((t) => {
    if (!t.deadline) return false;
    const deadlineDate = new Date(t.deadline);
    if (isNaN(deadlineDate)) return false;

    const diffInDays = Math.floor(
      (today - deadlineDate) / (1000 * 60 * 60 * 24),
    );

    return t.status === "in_progress" && diffInDays >= 2;
  }).length;

  // Resolved tickets
  const resolvedTickets = filteredTickets.filter(
    (t) => t.status === "resolved",
  ).length;

  // In-progress (excluding overdue)
  const inProgressTickets =
    filteredTickets.filter((t) => t.status === "in_progress").length -
    overdueTickets;

  // Totals
  const totalTickets = resolvedTickets + inProgressTickets + overdueTickets;

  return (
    <Box>
      {/* ======================== BANNER ======================== */}
      <Box
        sx={{
          position: "relative",
          width: isMobile ? "100vw" : "100%",
          height: "136px",
          marginX: isMobile ? -2 : 0,
          backgroundImage: `url(${Banner})`,
          backgroundSize: "cover",
          backgroundPosition: "top left",
          backgroundRepeat: "no-repeat",
          borderRadius: !isMobile ? "0 0  16px 16px" : 0,
        }}
      >
        {/* Overlay content */}
        <Box
          sx={{
            position: "absolute",
            margin: "0 auto",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 1,
            width: "90%",
          }}
        >
          <Typography
            sx={{
              mt: 2,
              width: 52,
              height: 52,
              boxShadow: 4,
              boxShadow: "inset -2px -2px 4px #005752",
              borderRadius: 4,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: 22,
              bgcolor: "#fff",
              color: "#008080",
            }}
          >
            {getInitials(userName)}
          </Typography>

          <Typography sx={{ fontSize: 14, color: "#fff" }}>
            {userName} | {availableRoles && availableRoles[userRole]}
          </Typography>
        </Box>

        {/* Buttons at bottom */}
        <Box
          sx={{
            flexGrow: 1,
            px: 2,
            position: "absolute",
            bottom: -24,
            width: "100%",
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Box
                onClick={() => setBtnStatus((prev) => (prev === 1 ? 0 : 1))}
                sx={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 1,
                  p: 2,
                  borderRadius: 2,
                  bgcolor: "#E49A00",
                  color: "#fff",
                  boxShadow: 12,
                  height: 48,
                  fontSize: 16,
                }}
              >
                {btnStatus === 0 ? "Recurring" : "Performance"}{" "}
                <Recurring style={{ width: "24px", height: "24px" }} />
              </Box>
            </Grid>

            {/* Today replaced with Date TextField */}
            <Grid item xs={6}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  p: 2,
                  borderRadius: 2,
                  bgcolor: "#fff",
                  boxShadow: 12,
                  height: 48,
                  fontSize: 16,
                }}
              >
                <TextField
                  type="date"
                  size="small"
                  value={selectedDate ? format(selectedDate, "yyyy-MM-dd") : ""}
                  onChange={(e) => {
                    if (!e.target.value) {
                      setSelectedDate(null);
                      return;
                    }
                    const newDate = new Date(e.target.value);
                    if (!isNaN(newDate)) setSelectedDate(newDate);
                  }}
                  variant="outlined"
                  sx={{
                    "& .MuiInputBase-root": {
                      fontSize: 14,
                      height: 24,
                      padding: 0,
                    },
                    "& input": {
                      padding: 0,
                    },
                    "& fieldset": {
                      border: "none",
                    },
                    "& .MuiOutlinedInput-root": {
                      "&.Mui-focused fieldset": {
                        border: "none",
                      },
                    },
                    width: "100%",
                  }}
                  InputProps={{
                    disableUnderline: true,
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>

      {/* ======================== RECURRING TICKET LIST ======================== */}
      {btnStatus === 1 && (
        <Box sx={{ mt: 6 }}>
          {!Array.isArray(recurringTickets) && (
            <Typography
              sx={{ fontSize: 16, color: "gray", textAlign: "center" }}
            >
              Loading Recurring Tickets
            </Typography>
          )}
          {Array.isArray(recurringTickets) && recurringTickets.length == 0 && (
            <Typography
              sx={{ fontSize: 16, color: "gray", textAlign: "center" }}
            >
              No Recurring Ticktes
            </Typography>
          )}

          {Array.isArray(recurringTickets) && recurringTickets.length > 0 && (
            <Box sx={{ flexGrow: 1, mt: 0.8, width: "100%" }}>
              <Grid container spacing={2}>
                {recurringTickets.map((ticket, index) => (
                  <Grid
                    item
                    xs={12}
                    sm={isMobile ? 12 : 4}
                    key={`${ticket.id}-${index}`}
                  >
                    <TicketCard ticket={ticket} />
                  </Grid>
                ))}
              </Grid>
            </Box>
          )}
        </Box>
      )}

      {/* ======================== TICKET PERFORMANCE ======================== */}
      {btnStatus === 0 && (
        <Box>
          {/* Ticket Performance Doughnut */}
          <Box
            sx={{
              mt: 6,
              mb: 1,
              p: 2,
              border: "1px solid #ddd",
              borderRadius: 2,
              display: "flex",
              alignItems: "center",
              gap: 2,
              bgcolor: "#fff",
            }}
          >
            {/* Doughnut Chart */}
            <Box sx={{ width: 124, height: 124, position: "relative" }}>
              <Doughnut
                data={{
                  labels: ["Resolved", "Overdue", "In Progress"],
                  datasets: [
                    {
                      data: [
                        resolvedTickets,
                        overdueTickets,
                        inProgressTickets,
                      ],
                      backgroundColor: ["#4caf50", "#f44336", "#ff9800"],
                      borderWidth: 0,
                    },
                  ],
                }}
                options={{
                  cutout: "65%",
                  plugins: {
                    legend: { display: false },
                    tooltip: { enabled: true },
                  },
                  maintainAspectRatio: false,
                }}
              />

              {/* Center % */}
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                  {totalTickets > 0
                    ? Math.round((resolvedTickets / totalTickets) * 100)
                    : 0}
                  %
                </Typography>
                <Typography variant="caption">Resolved</Typography>
              </Box>
            </Box>

            {/* Custom Legend */}
            <Box>
              {[
                { label: "Resolved", value: resolvedTickets, color: "#4caf50" },
                { label: "Overdue", value: overdueTickets, color: "#f44336" },
                {
                  label: "In Progress",
                  value: inProgressTickets,
                  color: "#ff9800",
                },
              ].map((item) => {
                const percentage = totalTickets
                  ? ((item.value / totalTickets) * 100).toFixed(0)
                  : 0;
                return (
                  <Box
                    key={item.label}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      my: 2,
                    }}
                  >
                    <Box
                      sx={{
                        width: 14,
                        height: 14,
                        borderRadius: "50%",
                        border: `1px solid ${item.color}`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mx: 1,
                      }}
                    >
                      <Box
                        sx={{
                          width: 8,
                          height: 8,
                          borderRadius: "50%",
                          backgroundColor: item.color,
                        }}
                      />
                    </Box>
                    <Typography sx={{ fontSize: 12 }}>
                      {item.label} ({percentage}%)
                    </Typography>
                  </Box>
                );
              })}
            </Box>
          </Box>

          {/* ======================== GOALS TABLE ======================== */}
          <Box
            sx={{
              border: "1px solid #ddd",
              borderRadius: 2,
              overflowX: "auto",
              mb: 2,
              p: 1,
              bgcolor: "#fff",
            }}
          >
            {/* Header row with title + week selector */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  fontSize: 14,
                  height: 56,
                  paddingLeft: 1.2,
                }}
              >
                <GoalIcon /> Daily Goals
              </Typography>

              {/* Week Selector */}
              <Box sx={{ height: 56, display: "flex", alignItems: "center" }}>
                <Select
                  size="small"
                  value={getISOWeek(selectedWeek)}
                  onChange={(e) => {
                    const currentWeek = getISOWeek(new Date());
                    const weeksBack = currentWeek - Number(e.target.value);
                    const newDate = new Date();
                    newDate.setDate(newDate.getDate() - weeksBack * 7);
                    setSelectedWeek(newDate);
                  }}
                  sx={{ mr: 1.2, width: 120, height: 30, fontSize: 14 }}
                  MenuProps={{
                    PaperProps: { style: { maxHeight: 200, fontSize: 14 } },
                  }}
                >
                  {weekOptions.map((w) => (
                    <MenuItem
                      sx={{ fontSize: 14 }}
                      key={w.value}
                      value={w.value}
                    >
                      {w.label}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
            </Box>

            {/* Goal Table Header */}
            <Box
              sx={{
                borderRadius: 2,
                display: "flex",
                p: 1,
                width: "100%",
                boxSizing: "border-box",
                bgcolor: "#008080",
                color: "white",
              }}
            >
              <Box
                sx={{
                  width: "35%",
                  textAlign: "left",
                  fontSize: 14,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Goal
              </Box>

              {weekdays.map((d, idx) => (
                <Box
                  key={idx}
                  sx={{
                    width: "10%",
                    textAlign: "center",
                    fontSize: 14,
                  }}
                >
                  {d}
                </Box>
              ))}

              <Box
                sx={{
                  width: "12%",
                  display: "flex",
                  justifyContent: "end",
                  fontSize: 14,
                }}
              >
                %
              </Box>
            </Box>

            {/* Rows */}
            {goalRows.map((row, idx) => {
              const goal = goals.find((g) => g.task_name === row.task_name);
              const target = goal?.target || 1;

              return (
                <Box
                  key={`${row.task_name}-${idx}`}
                  sx={{
                    display: "flex",
                    borderTop: "1px solid #eee",
                    p: 1,
                    width: "100%",
                    alignItems: "center",
                    boxSizing: "border-box",
                    overflow: "hidden",
                  }}
                >
                  {/* Goal name */}
                  <Box
                    sx={{
                      width: "35%",
                      pr: 1,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontSize: 12,
                    }}
                  >
                    {row.task_name}
                  </Box>

                  {/* Day cells */}
                  {weekdays.map((d, i) => {
                    const completed = row[d] || 0;
                    const pct = Math.min((completed / target) * 100, 100);
                    const c = colorForPct(pct);

                    return (
                      <Box
                        key={`${row.task_name}-${d}-${i}`}
                        sx={{
                          width: "10%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Box
                          title={`${completed}`}
                          sx={{
                            width: 14,
                            height: 14,
                            borderRadius: "50%",
                            border: `1px solid ${c}`,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {completed > 0 ? (
                            <Box
                              sx={{
                                width: 8,
                                height: 8,
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: 10,
                                color: c,
                                fontWeight: 600,
                              }}
                            >
                              {completed}
                            </Box>
                          ) : (
                            <Typography
                              sx={{
                                fontSize: 8,
                                color: c,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              {completed}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    );
                  })}

                  {/* Weekly average */}
                  <Box
                    sx={{
                      width: "12%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "end",
                    }}
                  >
                    <Typography sx={{ fontSize: 12 }}>{row.total}</Typography>
                  </Box>
                </Box>
              );
            })}
          </Box>

          {/* ======================== YES/NO TABLE (Yes‑rate based) ======================== */}
          {yesNoData &&
            yesNoData.questions &&
            yesNoData.questions.length > 0 && (
              <Box
                sx={{
                  border: "1px solid #ddd",
                  borderRadius: 2,
                  overflowX: "auto",
                  mb: 2,
                  p: 1,
                  bgcolor: "#fff",
                }}
              >
                {/* Header row – identical to Goals header */}
                <Box
                  sx={{
                    borderRadius: 2,
                    display: "flex",
                    p: 1,
                    width: "100%",
                    boxSizing: "border-box",
                    bgcolor: "#008080",
                    color: "white",
                  }}
                >
                  <Box
                    sx={{
                      width: "35%",
                      textAlign: "left",
                      fontSize: 14,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Question
                  </Box>

                  {weekdays.map((d, idx) => (
                    <Box
                      key={idx}
                      sx={{
                        width: "10%",
                        textAlign: "center",
                        fontSize: 14,
                      }}
                    >
                      {d}
                    </Box>
                  ))}

                  <Box
                    sx={{
                      width: "12%",
                      display: "flex",
                      justifyContent: "end",
                      fontSize: 14,
                    }}
                  >
                    Yes%
                  </Box>
                </Box>

                {/* Rows – one per question */}
                {yesNoData.questions.map((q, rowIdx) => {
                  // Count only "Yes" (answer === 1) among the displayed days
                  const yesCount = q.answers.filter(
                    (a) => a.answer === 1,
                  ).length;
                  const totalDays = q.answers.length; // Monday–Friday
                  const yesRate =
                    totalDays > 0
                      ? Math.round((yesCount / totalDays) * 100)
                      : 0;

                  return (
                    <Box
                      key={q.question_id}
                      sx={{
                        display: "flex",
                        borderTop: "1px solid #eee",
                        p: 1,
                        width: "100%",
                        alignItems: "center",
                        boxSizing: "border-box",
                        overflow: "hidden",
                      }}
                    >
                      {/* Question name */}
                      <Box
                        sx={{
                          width: "35%",
                          pr: 1,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          fontSize: 12,
                        }}
                      >
                        {q.question_text}
                      </Box>

                      {/* Day cells (Mon–Fri) */}
                      {q.answers.map((ans, colIdx) => {
                        const answer = ans.answer; // 1 = Yes, 0 = No, null = not submitted
                        const color =
                          answer === 1
                            ? "#4caf50"
                            : answer === 0
                            ? "#f44336"
                            : "#ccc";
                        const displayChar =
                          answer === 1 ? "Y" : answer === 0 ? "N" : "–";

                        return (
                          <Box
                            key={colIdx}
                            sx={{
                              width: "10%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Box
                              title={`${ans.date}: ${displayChar}`}
                              sx={{
                                width: 14,
                                height: 14,
                                borderRadius: "50%",
                                border: `1px solid ${color}`,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              {answer !== null ? (
                                <Box
                                  sx={{
                                    width: 8,
                                    height: 8,
                                    borderRadius: "50%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: 10,
                                    color: color,
                                    fontWeight: 600,
                                  }}
                                >
                                  {displayChar}
                                </Box>
                              ) : (
                                <Typography
                                  sx={{
                                    fontSize: 8,
                                    color: color,
                                    fontWeight: 600,
                                    lineHeight: 1,
                                  }}
                                >
                                  {displayChar}
                                </Typography>
                              )}
                            </Box>
                          </Box>
                        );
                      })}

                      {/* Weekly yes‑rate (coloured same as goals) */}
                      <Box
                        sx={{
                          width: "12%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "end",
                        }}
                      >
                        <Typography
                          sx={{ fontSize: 12, color: colorForPct(yesRate) }}
                        >
                          {yesRate}%
                        </Typography>
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            )}
        </Box>
      )}
    </Box>
  );
};

export default PerformanceStats;
